export default {
  install(app) {

    app.config.globalProperties.$calTableHeight = (rowsLength)=>{
      let minHeight = window.innerHeight - (65 + 28 + 202);
      let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 26;
      return Math.max(minHeight, calHeight);
    }
  }
}
